import React, { useContext, useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { CartContext } from "./CartContext";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem("user");

  const total = useMemo(() => {
    return cartItems.reduce((sum, item) => {
      const price =
        item.promo_active && item.promo_price ? Number(item.promo_price) : Number(item.price);
      return sum + price * Number(item.quantity || 1);
    }, 0);
  }, [cartItems]);

  const handleCheckout = () => {
    if (cartItems.length === 0) return;
    if (!isLoggedIn) return navigate("/login");
    navigate("/checkout-form");
  };

  return (
    <div className="page">
      <Helmet>
        <title>Panier – Deenzine</title>
        <meta name="description" content="Vérifie ton panier et finalise ta commande." />
        <link rel="canonical" href={window.location.origin + "/cart"} />
      </Helmet>

      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad">
            <h1 className="h2" style={{ color: "var(--brand)" }}>Votre panier</h1>
            <p className="p">Astuce : les stocks sont souvent limités sur les pièces faites main.</p>
          </div>

          <div style={{ height: 18 }} />

          {cartItems.length === 0 ? (
            <div className="card cardPad">
              Votre panier est vide. <a className="btn btnSecondary" href="/products" style={{ marginLeft: 10 }}>Voir la collection</a>
            </div>
          ) : (
            <div className="grid">
              <div style={{ gridColumn: "span 8" }}>
                {cartItems.map((item, index) => {
                  const unit =
                    item.promo_active && item.promo_price ? Number(item.promo_price) : Number(item.price);

                  return (
                    <div key={index} className="card cardPad" style={{ marginBottom: 14 }}>
                      <div className="cart-item-row" style={{ display: "flex", gap: 14, alignItems: "center" }}>
                        <img
                          src={item.image}
                          alt={item.name}
                          width="84"
                          height="84"
                          loading="lazy"
                          style={{
                            width: 84,
                            height: 84,
                            objectFit: "cover",
                            borderRadius: 14,
                            border: "1px solid var(--border)",
                          }}
                        />

                        <div style={{ flex: 1 }}>
                          <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
                            <div>
                              <div style={{ fontWeight: 800 }}>{item.name}</div>
                              {item.selectedColor && <div className="p">Couleur : {item.selectedColor}</div>}
                            </div>

                            <div style={{ textAlign: "right" }}>
                              {item.promo_active && item.promo_price ? (
                                <>
                                  <div style={{ textDecoration: "line-through", color: "rgba(0,0,0,.45)" }}>
                                    {Number(item.price).toFixed(2)} €
                                  </div>
                                  <div style={{ color: "var(--brand)", fontWeight: 900 }}>
                                    {Number(item.promo_price).toFixed(2)} €
                                  </div>
                                </>
                              ) : (
                                <div style={{ fontWeight: 900 }}>{Number(item.price).toFixed(2)} €</div>
                              )}
                            </div>
                          </div>

                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginTop: 12, flexWrap: "wrap" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                              <span className="p">Quantité</span>
                              <input
                                className="input"
                                type="number"
                                min={1}
                                value={item.quantity}
                                onChange={(e) => updateQuantity(item.id, item.selectedColor, e.target.value)}
                                style={{ width: 90 }}
                              />
                              {item.stock != null && (
                                <span className="p">/ stock {item.stock}</span>
                              )}
                            </div>

                            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                              <span className="badge">Sous-total : {(unit * Number(item.quantity || 1)).toFixed(2)} €</span>
                              <button className="btn btnDanger" onClick={() => removeFromCart(item.id, item.selectedColor)}>
                                Supprimer
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <aside style={{ gridColumn: "span 4" }}>
                <div className="card cardPad" style={{ position: "sticky", top: 18 }}>
                  <h2 className="h2" style={{ fontSize: 20, marginBottom: 8 }}>Récapitulatif</h2>
                  <div className="hr" />
                  <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 900 }}>
                    <span>Total</span>
                    <span>{total.toFixed(2)} €</span>
                  </div>
                  <p className="p" style={{ marginTop: 10 }}>
                    Paiement sécurisé via Stripe. Aucune donnée bancaire stockée.
                  </p>
                  <button className="btn" onClick={handleCheckout} style={{ width: "100%", marginTop: 14 }}>
                    Procéder au paiement →
                  </button>
                  {!isLoggedIn && (
                    <div className="badge" style={{ marginTop: 12 }}>
                      🔒 Connecte-toi pour payer
                    </div>
                  )}
                </div>
              </aside>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Cart;
